import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProjectStatsBadge from '../../components/ProjectStatsBadge';
import './Projects.css';

import opsMindImage from '../../assets/images/OpsMind AI.png';
import aiAdCreativeImage from '../../assets/images/ai ad creative.png';
import notesAppImge from '../../assets/images/Pk Notes App.png';
import smartExpenseImage from '../../assets/images/SmartExpense Photo.png';
import vistaHolidaysImage from '../../assets/images/Vista holidays Hero.png';
import docuVaultImage from '../../assets/images/DocuVault Hero.png';
import todoImage from '../../assets/images/To-Do-List-App Image.png';
import employeeImage from '../../assets/images/employeedailytask .jpeg';
import convertersImage from '../../assets/images/Converters App Image.png';
import aiPlatformImage from '../../assets/images/AI Powered Communication Platform.avif';
import cloudVendorImage from '../../assets/images/CloudVendor App Image.png';
import rfidImage from '../../assets/images/RFID Image.png';
import ticTacToeImage from '../../assets/images/tic-tac-toe App Image.png';

import easyHubImage from '../../assets/images/easyhub.png';
import aeroGlassImage from '../../assets/images/aeroglass.png';
import vortexImage from '../../assets/images/vorteximage.png';
import neonBiteImage from '../../assets/images/neonbite.png';
import tapAcademyImage from '../../assets/images/tapacademy.png';
import instagramCloneImage from '../../assets/images/instagramuiclone.png';
import spotifyCloneImage from '../../assets/images/spotifyuiclone.png';
import linkedinCloneImage from '../../assets/images/linkedinuiclone.png';
import netflixCloneImage from '../../assets/images/netflixuiclone.png';
import comingSoonImage from '../../assets/images/More Projects Coming Soon.jpeg';

const projectData = [
  {
    id: 3,
    name: 'Notes App Project',
    category: 'Software Applications',
    badge: 'MERN Stack',
    subtitle: 'Software Applications',
    description: 'A secure and modern MERN notes application with authentication, lock notes, shared links, subscription plans and more.',
    image: notesAppImge,
    link: '/projects/projectdetail/notes-app',
    docId: 'notesApp'
  },
  {
    id: 6,
    name: 'DocuVault',
    category: 'Software Applications',
    badge: 'Web Applications',
    subtitle: 'Software Applications',
    description: 'A secure document management platform to store, share and manage your files with advanced security features.',
    image: docuVaultImage,
    link: '/projects/projectdetail/docu-vault',
    docId: 'docuVault'
  },
  {
    id: 5,
    name: 'Vista Holidays',
    category: 'Software Applications',
    badge: 'MERN Stack',
    subtitle: 'Travel & Tourism',
    description: 'A modern travel booking platform with flight, hotel, holiday packages, currency conversion and secure payments.',
    image: vistaHolidaysImage,
    link: '/projects/projectdetail/vista-holidays',
    docId: 'vistaHolidays'
  },
  {
    id: 2,
    name: 'AI Ad Creative Generator',
    category: 'Software Applications',
    badge: 'AI & Machine Learning',
    subtitle: 'AI Tools',
    description: 'An AI powered ad creative generator to create stunning advertisements, social media posts and marketing visuals.',
    image: aiAdCreativeImage,
    link: '/ai-ad-creative-generator',
    docId: 'aiAdCreativeGenerator'
  },
  {
    id: 4,
    name: 'SmartExpense',
    category: 'Software Applications',
    badge: 'MERN Stack',
    subtitle: 'Expense Tracker',
    description: 'A comprehensive smart expense tracking and financial analytics dashboard to monitor budgets, incomes, and expenses.',
    image: smartExpenseImage,
    link: '/projects/projectdetail/smart-expense',
    docId: 'smartExpense'
  },
  {
    id: 1,
    name: 'OpsMind AI',
    category: 'Software Applications',
    badge: 'AI & Cloud Ops',
    subtitle: 'DevOps & AI Operations',
    description: 'An intelligent AI-powered operations and incident management system delivering automated diagnostic workflows.',
    image: opsMindImage,
    link: '/ops-mind-ai',
    docId: 'opsMindAI'
  },
  {
    id: 9,
    name: 'Converters App',
    category: 'Web Development',
    badge: 'Web Utilities',
    subtitle: 'Multi-Unit Utilities',
    description: 'An all-in-one real-time unit and currency converter suite designed with instant calculation and clean UI.',
    image: convertersImage,
    link: '/projects/projectdetail/converters-app-project',
    docId: 'convertersApp'
  },
  {
    id: 7,
    name: 'To-Do List App',
    category: 'Task Management',
    badge: 'Task Management',
    subtitle: 'Productivity Tool',
    description: 'A responsive task management app with category grouping, status prioritization, and persistent local storage.',
    image: todoImage,
    link: '/projects/projectdetail/to-do-list-app',
    docId: 'todoApp'
  },
  {
    id: 8,
    name: 'Employee Daily Task Allocation Management System',
    category: 'Software Applications',
    badge: 'Full Stack System',
    subtitle: 'Enterprise Management',
    description: 'A centralized employee task assignment and performance monitoring system with manager dashboards.',
    image: employeeImage,
    link: '/projects/projectdetail/employee-daily-task-allocation-management-system',
    docId: 'employeeTaskManager'
  },
  {
    id: 10,
    name: 'AI Powered Communication Platform for Deaf and Mute',
    category: 'AI Projects',
    badge: 'AI & Computer Vision',
    subtitle: 'Assistive Technology',
    description: 'An assistive communication platform bridging real-time gesture recognition to speech and text transcription.',
    image: aiPlatformImage,
    link: '/projects/projectdetail/ai-powered-communication-platform-for-deaf-and-mute',
    docId: 'aiCommunicationPlatform'
  },
  {
    id: 11,
    name: 'CloudVendor App using Java Spring Boot & MySQL JDBC',
    category: 'Software Applications',
    badge: 'Java & Spring Boot',
    subtitle: 'Backend & Cloud Services',
    description: 'A production-ready RESTful microservice managing enterprise cloud vendor resources with MySQL persistence.',
    image: cloudVendorImage,
    link: '/projects/projectdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc',
    docId: 'cloudVendorApp'
  },
  {
    id: 12,
    name: 'RFID Based Bus Number Announce System For Blind',
    category: 'Hardware Projects',
    badge: 'Hardware & IoT',
    subtitle: 'IoT & Embedded Systems',
    description: 'An assistive smart transport announcement system utilizing RFID tracking and automated voice output.',
    image: rfidImage,
    link: '/projects/projectdetail/rfid-based-bus-number-announce-system-for-blind',
    docId: 'rfidBusSystem'
  },
  {
    id: 13,
    name: 'Tic-Tac-Toe App',
    category: 'Software Applications',
    badge: 'Interactive Web App',
    subtitle: 'Interactive Game',
    description: 'A polished interactive classic Tic-Tac-Toe game featuring two-player modes, move history, and win detection.',
    image: ticTacToeImage,
    link: '/projects/projectdetail/tic-tac-toe-app',
    docId: 'ticTacToe'
  },
  {
    id: 14,
    name: 'AeroGlass Product Landing Page',
    category: 'Web Design',
    badge: 'Web Design & UI',
    subtitle: 'UI/UX Showcase',
    description: 'A futuristic glassmorphic product landing page highlighting modern aesthetic typography and smooth animations.',
    image: aeroGlassImage,
    link: '/projects/projectdetail/aeroglass-productlanding-page',
    docId: 'aeroGlassPage'
  },
  {
    id: 15,
    name: 'Easy Hub',
    category: 'Web Development',
    badge: 'Web Development',
    subtitle: 'Resource Portal',
    description: 'A unified developer resources hub and documentation aggregator built for swift developer onboarding.',
    image: easyHubImage,
    link: '/projects/projectdetail/easy-hub',
    docId: 'easyHub'
  },
  {
    id: 16,
    name: 'Instagram UI Clone',
    category: 'Software Applications',
    badge: 'Frontend Clone',
    subtitle: 'Social Media Interface',
    description: "A pixel-perfect responsive clone of Instagram's interface with feed posts, stories, reels, and profile views.",
    image: instagramCloneImage,
    link: '/projects/projectdetail/instagram-clone',
    docId: 'instagramClone'
  },
  {
    id: 17,
    name: 'LinkedIn UI Clone',
    category: 'Software Applications',
    badge: 'Frontend Clone',
    subtitle: 'Professional Network UI',
    description: 'A feature-rich recreation of the LinkedIn desktop and mobile interface with interactive feeds and profile sections.',
    image: linkedinCloneImage,
    link: '/projects/projectdetail/linkedin-clone',
    docId: 'linkedinClone'
  },
  {
    id: 18,
    name: 'Neon Bite Food Delivery',
    category: 'Web Development',
    badge: 'Web Development',
    subtitle: 'E-Commerce & Food',
    description: 'A cyberpunk-themed online food ordering platform with dynamic menu categories and cart checkout flow.',
    image: neonBiteImage,
    link: '/projects/projectdetail/neon-bite-food-Delivery',
    docId: 'neonBite'
  },
  {
    id: 19,
    name: 'Netflix UI Clone',
    category: 'Software Applications',
    badge: 'Frontend Clone',
    subtitle: 'Streaming Service UI',
    description: 'A high-fidelity Netflix UI clone featuring hero trailer previews, category rows, and responsive layouts.',
    image: netflixCloneImage,
    link: '/projects/projectdetail/netflix-clone',
    docId: 'netflixClone'
  },
  {
    id: 20,
    name: 'Spotify UI Clone',
    category: 'Software Applications',
    badge: 'Frontend Clone',
    subtitle: 'Audio & Music Streaming',
    description: 'A music player interface inspired by Spotify featuring playlist navigation, playback controls, and track cards.',
    image: spotifyCloneImage,
    link: '/projects/projectdetail/spotify-clone',
    docId: 'spotifyClone'
  },
  {
    id: 21,
    name: 'Tap Academy Clone',
    category: 'Web Design',
    badge: 'Web Design',
    subtitle: 'EdTech Platform',
    description: 'A modern educational technology website clone showcasing interactive course catalogs and curriculum schedules.',
    image: tapAcademyImage,
    link: '/projects/projectdetail/tap-academy-clone',
    docId: 'tapAcademy'
  },
  {
    id: 22,
    name: 'Vortex College Fest Website',
    category: 'Web Development',
    badge: 'Web Development',
    subtitle: 'Event Management',
    description: 'An engaging college festival website with event registrations, schedules, countdown timers, and gallery.',
    image: vortexImage,
    link: '/projects/projectdetail/vortex-college-fest',
    docId: 'vortexFest'
  },
  {
    id: 23,
    name: 'More Projects Coming Soon',
    category: 'Upcoming',
    badge: 'Upcoming Innovations',
    subtitle: 'In Active Development',
    description: 'Exciting new full-stack, AI, and creative technology projects currently being built and deployed.',
    image: comingSoonImage,
    link: '#'
  }
];

const categories = [
  'All',
  'Software Applications',
  'Web Design',
  'Hardware Projects',
  'Task Management',
  'Upcoming',
  'Web Development',
  'AI Projects'
];

// Category Icons
const getCategoryIcon = (category) => {
  switch (category) {
    case 'All':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm9 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V4zM3 12a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1v-4zm9 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z" />
        </svg>
      );
    case 'Software Applications':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm2 0v8h10V5H5z" clipRule="evenodd" />
        </svg>
      );
    case 'Web Design':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
        </svg>
      );
    case 'Hardware Projects':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4 9.236V15a1 1 0 00.553.894l4 2A1 1 0 0010 17V11.236a1 1 0 00-.553-.894l-4-2A1 1 0 004 9.236z" />
        </svg>
      );
    case 'Task Management':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
          <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      );
    case 'Upcoming':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
        </svg>
      );
    case 'Web Development':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4.083 9h11.834a8 8 0 01-1.05 4.312l-1.472-1.472A5.967 5.967 0 0014 9H6a5.967 5.967 0 00.605 2.84l-1.472 1.472A8.003 8.003 0 014.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm-6 8a6 6 0 1112 0 6 6 0 01-12 0z" clipRule="evenodd" />
        </svg>
      );
    case 'AI Projects':
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v1h8v-1zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 16.5a1.5 1.5 0 00-1.5-1.5h-.8a5.98 5.98 0 011.3 3h1.5v-1.5zM3.5 15A1.5 1.5 0 002 16.5V18h1.5a5.98 5.98 0 011.3-3h-.8z" />
        </svg>
      );
    default:
      return (
        <svg className="cat-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
      );
  }
};

// Badge Theme Classification
const getBadgeThemeClass = (badge, category) => {
  const text = `${badge || ''} ${category || ''}`.toLowerCase();
  if (text.includes('mern') || text.includes('spring') || text.includes('food')) return 'badge-amber';
  if (text.includes('ai') || text.includes('machine') || text.includes('creative') || text.includes('vision') || text.includes('netflix')) return 'badge-pink';
  if (text.includes('web app') || text.includes('design') || text.includes('ops') || text.includes('edtech')) return 'badge-purple';
  if (text.includes('hardware') || text.includes('iot') || text.includes('spotify') || text.includes('task')) return 'badge-emerald';
  if (text.includes('system') || text.includes('upcoming') || text.includes('linkedin')) return 'badge-indigo';
  return 'badge-cyan';
};

// Badge Icon Helper
const getBadgeIcon = (badge, category) => {
  const text = `${badge || ''} ${category || ''}`.toLowerCase();
  if (text.includes('mern')) return '🌐';
  if (text.includes('ai') || text.includes('machine')) return '🧠';
  if (text.includes('spring') || text.includes('java')) return '☕';
  if (text.includes('hardware') || text.includes('iot') || text.includes('rfid')) return '🔌';
  if (text.includes('design')) return '🎨';
  if (text.includes('task')) return '📋';
  if (text.includes('clone') || text.includes('mobile')) return '📱';
  if (text.includes('interactive') || text.includes('game')) return '🎮';
  if (text.includes('upcoming')) return '🚀';
  if (text.includes('system') || text.includes('management')) return '⚙️';
  if (text.includes('web app') || text.includes('app')) return '💻';
  return '🏷️';
};

// Hero Tech Graphic SVG Component
const ProjectsHeroIllustration = () => (
  <div className="hero-tech-graphic" aria-hidden="true">
    <svg
      viewBox="0 0 540 360"
      className="hero-svg-canvas"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Glow Filters */}
        <filter id="ambient-cyan-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="30" result="blur" />
        </filter>
        <filter id="ambient-purple-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="35" result="blur" />
        </filter>
        <filter id="badge-drop-shadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="8" stdDeviation="10" floodColor="#000000" floodOpacity="0.45" />
        </filter>

        {/* Gradients */}
        <radialGradient id="laptop-base-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#38bdf8" stopOpacity="0.35" />
          <stop offset="60%" stopColor="#818cf8" stopOpacity="0.12" />
          <stop offset="100%" stopColor="#0b1120" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="screen-bezel-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1e293b" />
          <stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
        <linearGradient id="screen-display-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#091326" />
          <stop offset="100%" stopColor="#040814" />
        </linearGradient>
        <linearGradient id="keyboard-chassis-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#334155" />
          <stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
        <linearGradient id="code-cyan-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#38bdf8" />
          <stop offset="100%" stopColor="#818cf8" />
        </linearGradient>
      </defs>

      {/* Ambient Radial Lighting Behind Graphic */}
      <circle cx="280" cy="180" r="140" fill="#38bdf8" opacity="0.15" filter="url(#ambient-cyan-glow)" />
      <circle cx="360" cy="140" r="110" fill="#c084fc" opacity="0.14" filter="url(#ambient-purple-glow)" />
      <ellipse cx="280" cy="275" rx="190" ry="45" fill="url(#laptop-base-glow)" />

      {/* Decorative Matrix & Orbital Wireframes */}
      <ellipse cx="280" cy="190" rx="210" ry="85" stroke="#38bdf8" strokeWidth="1" strokeDasharray="6 6" opacity="0.22" />
      <ellipse cx="280" cy="190" rx="160" ry="60" stroke="#818cf8" strokeWidth="1" strokeDasharray="3 7" opacity="0.18" />

      {/* LAPTOP ISOMETRIC 3D STRUCTURE */}
      <g className="laptop-3d-group">
        {/* Laptop Screen Display (Tilted upright) */}
        {/* Outer Glow Outline */}
        <rect x="176" y="78" width="208" height="142" rx="12" stroke="#38bdf8" strokeWidth="2" strokeOpacity="0.35" fill="none" />
        
        {/* Screen Bezel */}
        <rect x="180" y="82" width="200" height="134" rx="10" fill="url(#screen-bezel-grad)" stroke="#475569" strokeWidth="1" />
        
        {/* Inner Screen Display */}
        <rect x="188" y="90" width="184" height="118" rx="6" fill="url(#screen-display-grad)" />

        {/* Screen Window Header Controls */}
        <circle cx="198" cy="98" r="3" fill="#f87171" opacity="0.8" />
        <circle cx="206" cy="98" r="3" fill="#facc15" opacity="0.8" />
        <circle cx="214" cy="98" r="3" fill="#4ade80" opacity="0.8" />

        {/* Central Glowing Coding Symbol </> */}
        <g transform="translate(235, 120)">
          {/* Left Bracket < */}
          <path
            d="M 18,12 L 4,26 L 18,40"
            stroke="url(#code-cyan-grad)"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Slash / */}
          <path
            d="M 46,8 L 32,44"
            stroke="#ec4899"
            strokeWidth="4"
            strokeLinecap="round"
          />
          {/* Right Bracket > */}
          <path
            d="M 60,12 L 74,26 L 60,40"
            stroke="url(#code-cyan-grad)"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>

        {/* Screen Code Lines Accent */}
        <rect x="200" y="185" width="45" height="4" rx="2" fill="#38bdf8" opacity="0.5" />
        <rect x="252" y="185" width="75" height="4" rx="2" fill="#818cf8" opacity="0.4" />
        <rect x="333" y="185" width="25" height="4" rx="2" fill="#34d399" opacity="0.4" />

        {/* Laptop Hinge */}
        <rect x="240" y="216" width="80" height="6" rx="2" fill="#0f172a" />

        {/* Laptop Base / Keyboard Chassis */}
        <polygon
          points="130,222 430,222 470,268 90,268"
          fill="url(#keyboard-chassis-grad)"
          stroke="#475569"
          strokeWidth="1.5"
        />

        {/* Keyboard Recessed Area */}
        <polygon
          points="155,226 405,226 430,250 130,250"
          fill="#090d16"
          stroke="#1e293b"
          strokeWidth="1"
        />

        {/* Keyboard Key Rows Glow */}
        <line x1="162" y1="233" x2="398" y2="233" stroke="#38bdf8" strokeWidth="1.5" strokeOpacity="0.35" strokeDasharray="4 2" />
        <line x1="150" y1="241" x2="410" y2="241" stroke="#38bdf8" strokeWidth="1.5" strokeOpacity="0.35" strokeDasharray="5 3" />

        {/* Trackpad */}
        <polygon
          points="250,254 310,254 314,264 246,264"
          fill="#1e293b"
          stroke="#38bdf8"
          strokeWidth="1.2"
          strokeOpacity="0.6"
        />

        {/* Front Edge Highlight Bar */}
        <polygon
          points="90,268 470,268 468,272 92,272"
          fill="#0b1120"
        />
        <line x1="90" y1="268" x2="470" y2="268" stroke="#38bdf8" strokeWidth="1.5" strokeOpacity="0.75" />
      </g>

      {/* FLOATING TECH BADGES */}
      {/* 1. React Badge (Top-Left) */}
      <g className="floating-tech-badge float-badge-1" filter="url(#badge-drop-shadow)">
        <circle cx="105" cy="115" r="32" fill="#0b1329" stroke="#38bdf8" strokeWidth="2" />
        <circle cx="105" cy="115" r="5" fill="#61dafb" />
        <ellipse cx="105" cy="115" rx="20" ry="8" stroke="#61dafb" strokeWidth="1.8" fill="none" />
        <ellipse cx="105" cy="115" rx="20" ry="8" stroke="#61dafb" strokeWidth="1.8" fill="none" transform="rotate(60 105 115)" />
        <ellipse cx="105" cy="115" rx="20" ry="8" stroke="#61dafb" strokeWidth="1.8" fill="none" transform="rotate(120 105 115)" />
      </g>

      {/* 2. JavaScript Badge (Top-Center) */}
      <g className="floating-tech-badge float-badge-2" filter="url(#badge-drop-shadow)">
        <rect x="235" y="24" width="46" height="46" rx="10" fill="#f7df1e" stroke="#eab308" strokeWidth="1.5" />
        <text x="258" y="55" fill="#000000" fontSize="22" fontWeight="900" fontFamily="sans-serif" textAnchor="middle">JS</text>
      </g>

      {/* 3. MongoDB Badge (Top-Right) */}
      <g className="floating-tech-badge float-badge-3" filter="url(#badge-drop-shadow)">
        <rect x="400" y="65" width="105" height="42" rx="21" fill="#081422" stroke="#22c55e" strokeWidth="1.8" />
        {/* Leaf Graphic */}
        <path d="M 422,76 C 424,79 428,86 422,96 C 420,90 416,84 422,76 Z" fill="#22c55e" />
        <path d="M 422,76 C 422,86 424,96 422,96" stroke="#15803d" strokeWidth="1" />
        <text x="437" y="92" fill="#ffffff" fontSize="12" fontWeight="700" fontFamily="sans-serif">MongoDB</text>
      </g>

      {/* 4. Node.js Badge (Bottom-Left) */}
      <g className="floating-tech-badge float-badge-4" filter="url(#badge-drop-shadow)">
        <rect x="70" y="215" width="88" height="40" rx="20" fill="#081422" stroke="#22c55e" strokeWidth="1.8" />
        {/* Hexagon Node Icon */}
        <polygon points="86,226 94,222 102,226 102,236 94,240 86,236" fill="none" stroke="#22c55e" strokeWidth="2" />
        <text x="110" y="240" fill="#22c55e" fontSize="14" fontWeight="800" fontFamily="sans-serif">node</text>
      </g>

      {/* 5. Tailwind / Modern Web Wave Badge (Bottom-Right) */}
      <g className="floating-tech-badge float-badge-5" filter="url(#badge-drop-shadow)">
        <circle cx="445" cy="205" r="28" fill="#081422" stroke="#38bdf8" strokeWidth="2" />
        {/* Tailwind Wave Icon */}
        <path
          d="M 432,206 C 434,200 439,198 444,201 C 442,204 439,206 437,208 C 435,210 433,212 432,206 Z"
          fill="#38bdf8"
        />
        <path
          d="M 440,212 C 442,206 447,204 452,207 C 450,210 447,212 445,214 C 443,216 441,218 440,212 Z"
          fill="#38bdf8"
        />
      </g>

      {/* Sparkles / Ambient Neon Dots */}
      <circle cx="160" cy="65" r="2.5" fill="#38bdf8" opacity="0.8" />
      <circle cx="340" cy="40" r="2" fill="#c084fc" opacity="0.9" />
      <circle cx="380" cy="180" r="3" fill="#38bdf8" opacity="0.85" />
      <circle cx="120" cy="180" r="2" fill="#facc15" opacity="0.8" />
      <circle cx="485" cy="145" r="2.5" fill="#4ade80" opacity="0.8" />
    </svg>
  </div>
);

function Projects() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [isFiltering, setIsFiltering] = useState(false);

  const filteredProjects = projectData.filter(project => {
    const matchesCategory = selectedCategory === 'All' || project.category === selectedCategory;
    const query = searchQuery.trim().toLowerCase();
    const matchesSearch = query === '' ||
      project.name.toLowerCase().includes(query) ||
      project.category.toLowerCase().includes(query) ||
      (project.description && project.description.toLowerCase().includes(query)) ||
      (project.badge && project.badge.toLowerCase().includes(query)) ||
      (project.subtitle && project.subtitle.toLowerCase().includes(query));

    return matchesCategory && matchesSearch;
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 600);
    return () => clearTimeout(timeout);
  }, []);

  const handleCategoryChange = (category) => {
    if (selectedCategory === category) return;
    setIsFiltering(true);
    setTimeout(() => {
      setSelectedCategory(category);
      setIsFiltering(false);
    }, 200);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
  };

  const handleClearFilters = () => {
    setIsFiltering(true);
    setTimeout(() => {
      setSelectedCategory('All');
      setSearchQuery('');
      setIsFiltering(false);
    }, 200);
  };

  return (
    <div className="projects-page">
      {/* 1. HERO SECTION */}
      <section className="projects-hero-section">
        <div className="hero-background-glows" aria-hidden="true">
          <div className="glow-orb orb-top-left"></div>
          <div className="glow-orb orb-center-purple"></div>
          <div className="glow-orb orb-right-cyan"></div>
        </div>

        <div className="projects-hero-container">
          {/* Left Column: Heading, Subtitle, Badge */}
          <div className="projects-hero-left">
            <div className="hero-pill-badge">
              <span className="hero-badge-icon">📖</span>
              <span>My Work</span>
            </div>

            <h1 className="projects-hero-title">
              My <span className="projects-gradient-text">Projects</span>
            </h1>

            <p className="projects-hero-subtitle">
              A collection of web applications, AI tools and creative solutions built with modern technologies.
            </p>

            {/* Decorative Dot Matrix Grid */}
            <div className="hero-dots-matrix" aria-hidden="true">
              {[...Array(24)].map((_, i) => (
                <span key={i} className="dot-node" />
              ))}
            </div>
          </div>

          {/* Right Column: 3D Isometric Tech Graphic */}
          <div className="projects-hero-right">
            <ProjectsHeroIllustration />
          </div>
        </div>
      </section>

      {/* 2. FLOATING SEARCH & CATEGORY FILTER TOOLBAR */}
      <div className="projects-toolbar-wrapper">
        <div className="projects-toolbar-card">
          {/* Search Input Box */}
          <div className="toolbar-search-box">
            <svg className="toolbar-search-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
            <input
              type="text"
              className="toolbar-search-input"
              placeholder="Search Projects..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery.trim() !== '' && (
              <button
                type="button"
                className="toolbar-search-clear"
                onClick={handleClearSearch}
                aria-label="Clear Search"
              >
                ✕
              </button>
            )}
          </div>

          {/* Category Filter Pills */}
          <div className="toolbar-categories">
            {categories.map((category) => (
              <button
                key={category}
                type="button"
                className={`category-pill-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category)}
              >
                {getCategoryIcon(category)}
                <span>{category}</span>
              </button>
            ))}
          </div>

          {/* Clear Filter Button */}
          <button
            type="button"
            className="toolbar-clear-btn"
            onClick={handleClearFilters}
            title="Reset all filters"
          >
            <svg className="toolbar-clear-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <span>Clear Filter</span>
          </button>
        </div>
      </div>

      {/* 3. MAIN PROJECTS CONTENT AREA */}
      <main className="projects-content-container">
        {loading ? (
          <div className="projects-loader-container">
            <div className="projects-loader-spinner"></div>
            <p className="projects-loader-text">Loading portfolio showcase...</p>
          </div>
        ) : (
          <>
            {filteredProjects.length > 0 ? (
              <div className={`projects-grid ${isFiltering ? 'fade-out' : 'fade-in'}`}>
                {filteredProjects.map((project) => {
                  const badgeTheme = getBadgeThemeClass(project.badge, project.category);
                  const badgeIcon = getBadgeIcon(project.badge, project.category);
                  const badgeText = project.badge || project.category;

                  return (
                    <article className="project-card" key={project.id}>
                      {/* Left Column: Image */}
                      <div className="project-card-image-wrapper">
                        <img
                          src={project.image}
                          alt={project.name}
                          className="project-card-image"
                          loading="lazy"
                        />
                      </div>

                      {/* Right Column: Details */}
                      <div className="project-card-details">
                        <div className="project-card-top">
                          {/* Category Badge Pill */}
                          <div className={`project-category-badge ${badgeTheme}`}>
                            <span className="badge-icon">{badgeIcon}</span>
                            <span className="badge-label">{badgeText}</span>
                          </div>

                          {/* Project Title */}
                          <h3 className="project-card-title">{project.name}</h3>

                          {/* Subtitle / Tag */}
                          <p className="project-card-subtitle">
                            {project.subtitle || project.category}
                          </p>

                          {/* Description */}
                          <p className="project-card-desc">
                            {project.description || `${project.name} - Modern web application built with clean architecture and responsive UI.`}
                          </p>
                        </div>

                        <div className="project-card-bottom">
                          {/* Real-time Likes and Views */}
                          {project.docId && (
                            <div className="project-stats-wrapper">
                              <ProjectStatsBadge docId={project.docId} />
                            </div>
                          )}

                          {/* View Project Details Button */}
                          <div className="project-action-wrapper">
                            {project.link !== '#' ? (
                              <Link to={project.link} className="project-action-link">
                                <button className="view-details-btn">
                                  <span>→ View Project Details</span>
                                </button>
                              </Link>
                            ) : (
                              <button className="view-details-btn coming-soon-btn" disabled>
                                <span>Coming Soon</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>
            ) : (
              <div className="no-projects-found-card">
                <div className="no-projects-icon-wrap">
                  <span className="no-projects-emoji">🔍</span>
                </div>
                <h3 className="no-projects-title">No matching projects found</h3>
                <p className="no-projects-subtitle">
                  We couldn't find any projects matching &quot;{searchQuery}&quot; in category &quot;{selectedCategory}&quot;.
                </p>
                <button
                  type="button"
                  className="no-projects-reset-btn"
                  onClick={handleClearFilters}
                >
                  Reset Filters
                </button>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default Projects;